export const BUFFER_TIMES_OPTIONS = [
    {
        name: 'Off',
        value: 0
    },
    {
        name: '5 mins',
        value: 5
    },
    {
        name: '10 mins',
        value: 10
    },
    {
        name: '15 mins',
        value: 15
    },
    {
        name: '20 mins',
        value: 20
    },
    {
        name: '25 mins',
        value: 25
    },
    {
        name: '30 mins',
        value: 30
    },
    {
        name: '35 mins',
        value: 35
    },
    {
        name: '40 mins',
        value: 40
    },
    {
        name: '45 mins',
        value: 45
    },
    {
        name: '50 mins',
        value: 50
    },
    {
        name: '55 mins',
        value: 55
    },
    {
        name: '1 hr',
        value: 60
    },
    {
        name: '1 hr 30 min',
        value: 90
    },
    {
        name: '2 hrs',
        value: 120
    },
    {
        name: '2 hrs 30 min',
        value: 150
    },
    {
        name: '3 hrs',
        value: 180
    }
];
